const UNIT_LOCATION = {
    MANITOBA: 'mb',
};

export default UNIT_LOCATION;
